function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.81 10.67a9 9 0 01-3-.46 1.26 1.26 0 00-1.19.27l-1.81 1.35a10.26 10.26 0 01-4.68-4.62l1.41-1.82a1.13 1.13 0 00.26-1.2 11.18 11.18 0 01-.41-3A1.2 1.2 0 004.19 0h-3A1.18 1.18 0 000 1.17 14.81 14.81 0 0014.81 16 1.2 1.2 0 0016 14.81v-3a1.2 1.2 0 00-1.19-1.14z",
  fill: "#61c250"
});

function SvgPhone(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 16.03 16"
  }, props), _ref);
}

export default __webpack_public_path__ + "assets/images/phone.f68f7710.svg";
export { SvgPhone as ReactComponent };